import { Link } from "react-router-dom";
import ScrollRow from "@components/layout/ScrollRow";

export default function ContinueWatchingSection({ items }) {
  return (
    <section className="home-continue-row" style={{ padding: "28px 52px 0" }}>
      <div
        style={{
          fontSize: 32,
          fontWeight: 600,
          color: "#fff",
          textTransform: "uppercase",
          marginBottom: 14,
        }}
        className="jost-s"
      >
        Продолжить просмотр
      </div>
      <ScrollRow cardStyle="calc((100% - 40px) / 5)">
        {items.map((item) => {
          const Wrapper = item.href ? Link : "div";
          const wrapperProps = item.href ? { to: item.href } : {};

          return (
            <Wrapper
              key={item.id}
              {...wrapperProps}
              style={{
                cursor: item.href ? "pointer" : "default",
                borderRadius: 6,
                overflow: "hidden",
                background: "#000000",
                color: "inherit",
                display: "block",
                textDecoration: "none",
              }}
            >
            <div
              style={{
                position: "relative",
                width: "100%",
                paddingTop: "56.25%",
                overflow: "hidden",
              }}
            >
              <img
                src={item.img}
                alt={item.title}
                style={{
                  position: "absolute",
                  inset: 0,
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  opacity: 0.88,
                }}
              />
              <div
                style={{
                  position: "absolute",
                  bottom: 5,
                  right: 5,
                  color: "#fff",
                  fontSize: 13,
                  background: "rgba(0, 0, 0, 0.12)",
                  width: "auto",
                  minWidth: 106,
                  height: 32,
                  backdropFilter: "blur(2px)",
                  borderRadius: 3,
                  borderTopLeftRadius: "200px",
                  borderBottomLeftRadius: "200px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "0 11px",
                  whiteSpace: "nowrap",
                }}
                className="inter-m"
              >
                {item.duration}
              </div>
            </div>
            <div style={{ height: 6, background: "#A2A2A2" }}>
              <div
                style={{
                  height: "100%",
                  width: `${item.progress}%`,
                  background: "#354BCA",
                  borderTopRightRadius: "200px",
                  borderBottomRightRadius: "200px",
                }}
              />
            </div>
            <div
              style={{
                padding: "6px 4px",
                fontSize: 20,
                color: "#ACACAC",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
              className="jost-s"
            >
              {item.title}
            </div>
            </Wrapper>
          );
        })}
      </ScrollRow>
    </section>
  );
}
